module.exports = __webpack_public_path__ + "media/images/default_bg-24e5d7f5c74666c7e827c0bf8ae86fde.jpg";